import React from 'react';

const track = (name, props = {}) => {
  try {
    if (window.ahoy && typeof window.ahoy.track === 'function') {
      window.ahoy.track(name, props);
    }
  } catch (_) {}
};

// Wrapper around the icon button + label
const wrapperClasses = [
  'flex', 'flex-col', 'items-center', 'justify-start', 'text-center',
  'transition-transform', 'duration-200',
];

const comingSoonClasses = ['opacity-60', 'cursor-not-allowed'];
const enabledClasses = ['hover:scale-105', 'cursor-pointer'];

const ComingSoonPill = () => (
  <div className="text-gray-500" style={{ marginTop: '6px', fontSize: '9px', lineHeight: '12px' }}>
    Coming Soon
  </div>
);

const ToolTile = ({ label, href, comingSoon = false, category, icon: IconComponent }) => {
  const handleClick = (e) => {
    if (comingSoon) {
      e.preventDefault();
      return;
    }
    track('home_tile_click', { tile_label: label, category, destination: href });
  };

  const wrapperClassName = [
    ...wrapperClasses,
    ...(comingSoon ? comingSoonClasses : enabledClasses),
  ].join(' ');
  // Square icon button area (outside label) – force square regardless of global CSS
  const buttonClasses = [
    'bg-white', 'rounded-lg', 'border', 'border-gray-200',
    'flex', 'items-center', 'justify-center',
  ].join(' ');
  const squareStyle = { width: '54px', height: '54px', padding: '6px' };

  const content = (
    <div className={wrapperClassName}>
      <div className={buttonClasses} style={squareStyle} aria-hidden="true">
        <div className={`${comingSoon ? 'text-gray-400' : 'text-gray-700'}`}>
          {IconComponent ? <IconComponent className="w-6 h-6" /> : null}
        </div>
      </div>
      <span
        className={`${comingSoon ? 'text-gray-400' : 'text-gray-900'} font-medium`}
        style={{ display: 'block', marginTop: '6px', fontSize: '9px', lineHeight: '12px' }}
      >
        {label}
      </span>
      {comingSoon && <ComingSoonPill />}
    </div>
  );

  if (comingSoon || !href) return <div>{content}</div>;
  return (
    <a href={href} className="inline-block" onClick={handleClick} aria-label={label}>
      {content}
    </a>
  );
};

export default ToolTile;


